// @flow
import React from "react";
import styled, { css } from "styled-components";
import { media, SmartLink } from "@nested/ui";

const DetailedMenuItemStyle = styled.li`
  margin-top: 10px;
  a {
    display: inline;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.93;
    letter-spacing: 1.8px;
    color: #353f52;
  }

  a:hover {
    padding-bottom: 3px;
    border-bottom: 2px solid #353f52;
  }

  ${media.tablet`
    margin-top: 0px;
    a {
      display: block;
      width: 345px;
      padding: 13px;
      text-align: left;
      border: 1px solid transparent;
      margin-top: 0px;
    }

    a:hover {
      padding: 13px;
      border-radius: 2px;
      background-color: #f7fbff;
      border: solid 1px #eef3fe;
    }
  `};
`;

const Detail = styled.p`
  display: none;
  text-transform: none;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.63;
  letter-spacing: normal;
  margin: 0px;
  ${media.tablet`
    display: block;
  `};
`;

const MenuItemStyle = styled.li`
  margin-top: 10px;
  line-height: 1.93;
  text-align: left;
  a {
    white-space: nowrap;
    display: inline;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.93;
    letter-spacing: 1.8px;
    color: #353f52;
  }

  a:hover {
    padding-bottom: 3px;
    border-bottom: 2px solid #353f52;
  }

  ${media.tablet`
    margin-top: 0px;
    padding: 13px;

  `};

  /*
   * Menu items with the hide prop appear in the 'More' section of the desktop nav
   * at certain viewport sizes, and are always hidden on mobile. For example, a
   * menu item with hide="lg" is hidden until md (the mobile breakpoint), then shown
   * between md and lg, and then hidden from lg and above. !important is used because
   * these menu items already have more specific display attributes which need to be 
   * overwritten.
   */
  ${({ hide }) =>
    hide &&
    css`
      display: none !important;

      ${media.tablet`
        display: block !important;
      `};
      @media (min-width: ${hide / 16}em) {
        display: none !important;
      }
    `};
`;

type DetailedMenuItemProps = {
  to: string,
  title: string,
  detail: string,
};

export const DetailedMenuItem = ({
  to,
  title,
  detail,
}: DetailedMenuItemProps) => (
  <DetailedMenuItemStyle>
    <SmartLink to={to}>
      {title}
      <Detail>{detail}</Detail>
    </SmartLink>
  </DetailedMenuItemStyle>
);

type MenuItemProps = {
  to: string,
  title: string,
  hide?: number,
};

export const MenuItem = ({ to, title, hide }: MenuItemProps) => (
  <MenuItemStyle hide={hide}>
    <SmartLink to={to}>{title}</SmartLink>
  </MenuItemStyle>
);
